export function getValuesForSelect(data, value, label, optionalValue) {

    var values = []

    if (optionalValue) values.push({ value: 0, label: optionalValue })

    for (let i = 0; i < data.length; i++) {
        const item = data[i]

        values.push({
            value: item[value],
            label: item[label]
        })
    }

    return values
}
export function getValuesForSelectCustomer(data, value, label, labelLN, optionalValue) {

    var values = []

    if (optionalValue) values.push({ value: 0, label: optionalValue })

    for (let i = 0; i < data.length; i++) {
        const item = data[i]

        values.push({
            value: item[value],
            label: `${item[label]} ${item[labelLN]}`
        })
    }

    return values
}
export function getYearsForSelect() {
    var actualYear = parseInt((new Date()).getFullYear());
    var years = [];
    for (let i = 2017; i <= actualYear; i++) {
        years.push({ value: i, label: i });
    }
    return years;
}

export function getFromDataByLabel(label, id, data) {

    for (let i = 0; i < data.length; i++) {
        if (data[i][label] == id) {
            return data[i];
        }
    }
    return null;
}




// WEBPACK FOOTER //
// ./src/common/helpers/select.js